import { lazyWithReload } from '../../utils/lazyWithReload';
/**
 * Registers standalone page renderers for Automation / Agent entity types.
 *
 * Import this file as a side effect once at app startup (done from appRegistryStore.ts).
 * The registry is a singleton so it's safe to import multiple times (idempotent Map.set).
 *
 * The rendered component is <AutomationsApp> in renderMode="standalone" standaloneMode="layout"
 * (no WindowWrapper — StandaloneEntityLayout provides outer chrome instead).
 */

import React from 'react';
import { entityStandaloneRegistry, StandaloneRendererContext, FloatingPanelOverrides } from '../../components/StandaloneEntity/entityStandaloneRegistry';

// Lazy-load to avoid pulling AutomationsApp into the main bundle
const AutomationsApp = lazyWithReload(() => import('./AutomationsApp'));

function renderAutomation(ctx: StandaloneRendererContext) {
  const viewerMode = ctx.isOwner ? 'owner'
    : ctx.role === 'editor' ? 'editor'
    : ctx.isPublicViewer ? 'public'
    : ctx.role === 'commenter' ? 'commenter'
    : ctx.role === 'viewer' ? 'viewer'
    : 'public';

  return React.createElement(AutomationsApp, {
    windowId: `standalone-automation-${ctx.entity._id || ctx.entity.id || 'unknown'}`,
    spaceId: 'default',
    entity: ctx.entity,
    renderMode: 'standalone',
    standaloneMode: 'layout',
    viewerMode: viewerMode as any,
  });
}

const loadingNode = React.createElement(
  'div',
  {
    style: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%',
      color: 'rgba(255,255,255,0.4)',
      fontSize: 14,
    },
  },
  'Loading automation…'
);

function automationFloatingPanelProps(ctx: StandaloneRendererContext): FloatingPanelOverrides | undefined {
  if (!ctx.isPublicViewer) return undefined;
  const entityId = ctx.entity._id || (ctx.entity as any).id || '';
  const returnTo = encodeURIComponent(`/automations/${entityId}`);
  return {
    primaryCta: {
      label: 'Install & run this automation',
      href: `/signup?intent=install-automation&entityId=${entityId}&returnTo=${returnTo}`,
    },
    secondaryCta: {
      label: 'Sign up free',
      href: '/signup',
    },
  };
}

const automationRenderer = {
  appId: 'automations',
  render: renderAutomation,
  renderLoading: () => loadingNode,
  floatingPanelProps: automationFloatingPanelProps,
};

entityStandaloneRegistry.register('Automation', automationRenderer);
entityStandaloneRegistry.register('Agent', automationRenderer);
entityStandaloneRegistry.register('OrchestratorAgent', automationRenderer);
